import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Adjust path as needed

const TicketAgeCategories = () => {
  const tableRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [ageCategories, setAgeCategories] = useState([
    { category: "Infants & Toddlers (Below 6 years)", status: "Active", id: 1 },
    { category: "Children", status: "Inactive", id: 2 },
    { category: "Adults", status: "Active", id: 3 },
  ]);

  const [formData, setFormData] = useState({
    category: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [ageCategories]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedCategory) {
      setAgeCategories(
        ageCategories.map((cat) =>
          cat.id === selectedCategory.id ? { ...formData, id: cat.id } : cat
        )
      );
    } else {
      setAgeCategories([
        ...ageCategories,
        { ...formData, id: ageCategories.length ? ageCategories[ageCategories.length - 1].id + 1 : 1 },
      ]);
    }
    setShowForm(false);
    setFormData({ category: "", status: "Active" });
    setSelectedCategory(null);
  };

  const handleEdit = (category) => {
    setSelectedCategory(category);
    setFormData({ category: category.category, status: category.status });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedCategory(null);
    setFormData({ category: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="ticket-age-category-page d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {/* Left-side Form Panel */}
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "300px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedCategory ? "Edit Age Category" : "Add Age Category"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Age Category:</label>
              <input
                type="text"
                name="category"
                value={formData.category}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">Save</button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Table Section */}
      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>Ticket Age Categories</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add Age Category
            </button>
          </div>
          <div className="card-body">
            <table ref={tableRef} className="table table-bordered display" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>Age Category</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {ageCategories.map((cat) => (
                  <tr key={cat.id}>
                    <td>{cat.category}</td>
                    <td>
                      <span className={`badge ${cat.status === "Active" ? "bg-success" : "bg-danger"}`}>
                        {cat.status}
                      </span>
                    </td>
                    <td>
                      <button className="btn btn-warning btn-sm" onClick={() => handleEdit(cat)}>
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketAgeCategories;
